import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsViberComponent } from './simple-icons-viber.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsViberComponent ],
    exports:      [ SimpleIconsViberComponent ],
    bootstrap:    []
})
export class SimpleIconsViberModule {}
